import { SET_FORCE_UNLOCK_MENU } from '@/store/modules/societe-mutation-type';

export default function reinitialiseUnlockMenu(store) {
  store.commit(`societe/${SET_FORCE_UNLOCK_MENU}`, false);
}
